import i18n, { type Config } from 'sveltekit-i18n';

export const defaultLocale = 'en';

interface Params {
	[key: string]: string | number | boolean | undefined | null;
	// add more parameters that are used here
}

const myConfig: Config<Params> = {
	fallbackLocale: defaultLocale,
	loaders: [
		// COMMON
		{
			locale: 'en',
			key: 'common',
			loader: async () => (await import('../i18n/en/common.json')).default
		},
		{
			locale: 'fr',
			key: 'common',
			loader: async () => (await import('../i18n/fr/common.json')).default
		},
		{
			locale: 'nl',
			key: 'common',
			loader: async () => (await import('../i18n/nl/common.json')).default
		},

		// HOME
		{
			locale: 'en',
			key: 'home',
			routes: ['', '/'],
			loader: async () => (await import('../i18n/en/home')).default
		},
		{
			locale: 'fr',
			key: 'home',
			routes: ['', '/'],
			loader: async () => (await import('../i18n/fr/home')).default
		},
		{
			locale: 'nl',
			key: 'home',
			routes: ['', '/'],
			loader: async () => (await import('../i18n/nl/home')).default
		},

		// Checkups
		{
			locale: 'en',
			key: 'checkups',
			routes: ['', /checkups/],
			loader: async () => (await import('../i18n/en/checkups')).default
		},
		{
			locale: 'fr',
			key: 'checkups',
			routes: ['', /checkups/],
			loader: async () => (await import('../i18n/fr/checkups')).default
		},
		{
			locale: 'nl',
			key: 'checkups',
			routes: ['', /checkups/],
			loader: async () => (await import('../i18n/nl/checkups')).default
		},

		// Bloodtests
		{
			locale: 'en',
			key: 'bloodtest',
			routes: ['', /bloodtest/],
			loader: async () => (await import('../i18n/en/bloodtest')).default
		},
		{
			locale: 'fr',
			key: 'bloodtest',
			routes: ['', /bloodtest/],
			loader: async () => (await import('../i18n/fr/bloodtest')).default
		},
		{
			locale: 'nl',
			key: 'bloodtest',
			routes: ['', /bloodtest/],
			loader: async () => (await import('../i18n/nl/bloodtest')).default
		},

		// about
		{
			locale: 'en',
			key: 'about',
			routes: [/about/],
			loader: async () => (await import('../i18n/en/about')).default
		},
		{
			locale: 'fr',
			key: 'about',
			routes: [/about/],
			loader: async () => (await import('../i18n/fr/about')).default
		},
		{
			locale: 'nl',
			key: 'about',
			routes: [/about/],
			loader: async () => (await import('../i18n/nl/about')).default
		},

		// care
		{
			locale: 'en',
			key: 'care',
			routes: [/care/],
			loader: async () => (await import('../i18n/en/care')).default
		},
		{
			locale: 'fr',
			key: 'care',
			routes: [/care/],
			loader: async () => (await import('../i18n/fr/care')).default
		},
		{
			locale: 'nl',
			key: 'care',
			routes: [/care/],
			loader: async () => (await import('../i18n/nl/care')).default
		},

		// TESTS AND BIOMARKERS
		{
			locale: 'en',
			key: 'testsAndBiomarkers',
			routes: [/tests-and-biomarkers/],
			loader: async () => (await import('../i18n/en/tests-and-biomarkers')).default
		},
		{
			locale: 'fr',
			key: 'testsAndBiomarkers',
			routes: [/tests-and-biomarkers/],
			loader: async () => (await import('../i18n/fr/tests-and-biomarkers')).default
		},
		{
			locale: 'nl',
			key: 'testsAndBiomarkers',
			routes: [/tests-and-biomarkers/],
			loader: async () => (await import('../i18n/nl/tests-and-biomarkers')).default
		},
		// labs
		{
			locale: 'en',
			key: 'labs',
			routes: [/labs/],
			loader: async () => (await import('../i18n/en/labs')).default
		},
		{
			locale: 'fr',
			key: 'labs',
			routes: [/labs/],
			loader: async () => (await import('../i18n/fr/labs')).default
		},
		{
			locale: 'nl',
			key: 'labs',
			routes: [/labs/],
			loader: async () => (await import('../i18n/nl/labs')).default
		},

		// labs
		{
			locale: 'en',
			key: 'business',
			routes: [/business/],
			loader: async () => (await import('../i18n/en/business.json')).default
		},
		{
			locale: 'fr',
			key: 'business',
			routes: [/business/],
			loader: async () => (await import('../i18n/fr/business.json')).default
		},
		{
			locale: 'nl',
			key: 'business',
			routes: [/business/],
			loader: async () => (await import('../i18n/nl/business.json')).default
		},

		// HOW
		//
		{
			locale: 'en',
			key: 'how',
			routes: [/how/, /checkups/],
			loader: async () => (await import('../i18n/en/how.json')).default
		},
		{
			locale: 'fr',
			key: 'how',
			routes: [/how/, /checkups/],
			loader: async () => (await import('../i18n/fr/how.json')).default
		},
		{
			locale: 'nl',
			key: 'how',
			routes: [/how/, /checkups/],
			loader: async () => (await import('../i18n/nl/how.json')).default
		},

		// FAQ
		//
		{
			locale: 'en',
			key: 'faq',
			routes: [/faq/],
			loader: async () => (await import('../i18n/en/faq')).default
		},
		{
			locale: 'fr',
			key: 'faq',
			routes: [/faq/],
			loader: async () => (await import('../i18n/fr/faq')).default
		},
		{
			locale: 'nl',
			key: 'faq',
			routes: [/faq/],
			loader: async () => (await import('../i18n/nl/faq')).default
		},

		// Legal
		{
			locale: 'en',
			key: 'legal',
			routes: [/legal/],
			loader: async () => (await import('../i18n/en/legal.json')).default
		},
		{
			locale: 'fr',
			key: 'legal',
			routes: [/legal/],
			loader: async () => (await import('../i18n/fr/legal.json')).default
		},

		// TERMS
		{
			locale: 'en',
			key: 'terms',
			routes: [/terms/],
			loader: async () => (await import('../i18n/en/terms')).default
		},
		{
			locale: 'fr',
			key: 'terms',
			routes: [/terms/],
			loader: async () => (await import('../i18n/fr/terms')).default
		},

		{
			locale: 'nl',
			key: 'terms',
			routes: [/terms/],
			loader: async () => (await import('../i18n/nl/terms')).default
		},
		// PRIVACY
		{
			locale: 'en',
			key: 'privacy',
			routes: [/privacy/],
			loader: async () => (await import('../i18n/en/privacy')).default
		},
		{
			locale: 'fr',
			key: 'privacy',
			routes: [/privacy/],
			loader: async () => (await import('../i18n/fr/privacy')).default
		},

		{
			locale: 'nl',
			key: 'privacy',
			routes: [/privacy/],
			loader: async () => (await import('../i18n/nl/privacy')).default
		},
		// COOKIE
		{
			locale: 'en',
			key: 'cookies',
			loader: async () => (await import('../i18n/en/cookies')).default
		},
		{
			locale: 'fr',
			key: 'cookies',
			loader: async () => (await import('../i18n/fr/cookies')).default
		},

		{
			locale: 'nl',
			key: 'cookies',
			loader: async () => (await import('../i18n/nl/cookies')).default
		},

		// TERMS WEBSITE
		{
			locale: 'en',
			key: 'terms-website',
			routes: ['/terms-website'],
			loader: async () => (await import('../i18n/en/terms_website')).default
		},
		{
			locale: 'fr',
			key: 'terms-website',
			routes: ['/terms-website'],
			loader: async () => (await import('../i18n/fr/terms_website')).default
		},

		{
			locale: 'nl',
			key: 'terms-website',
			routes: ['/terms-website'],
			loader: async () => (await import('../i18n/nl/terms_website')).default
		},

		// SOON
		{
			locale: 'en',
			key: 'soon',
			loader: async () => (await import('../i18n/en/soon')).default
		},
		{
			locale: 'fr',
			key: 'soon',
			loader: async () => (await import('../i18n/fr/soon')).default
		},
		{
			locale: 'nl',
			key: 'soon',
			loader: async () => (await import('../i18n/nl/soon')).default
		},

		// JOIN
		{
			routes: ['/join'],
			locale: 'en',
			key: 'join',
			loader: async () => (await import('../i18n/en/join.json')).default
		},
		{
			routes: ['/join'],
			locale: 'fr',
			key: 'join',
			loader: async () => (await import('../i18n/fr/join.json')).default
		},
		{
			routes: ['/join'],
			locale: 'nl',
			key: 'join',
			loader: async () => (await import('../i18n/nl/join.json')).default
		},

		// doctors
		{
			routes: ['/doctors'],
			locale: 'en',
			key: 'doctors',
			loader: async () => (await import('../i18n/en/doctors')).default
		},
		{
			routes: ['/doctors'],
			locale: 'fr',
			key: 'doctors',
			loader: async () => (await import('../i18n/fr/doctors')).default
		},
		{
			routes: ['/doctors'],
			locale: 'nl',
			key: 'doctors',
			loader: async () => (await import('../i18n/nl/doctors')).default
		}
	]
};

export const {
	t,
	locale,
	locales,
	loading,
	loadTranslations,
	translations,
	addTranslations,
	setLocale,
	setRoute
} = new i18n(myConfig);
